import _defineProperty from "/vercel/path0/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/defineProperty.js";
import _objectWithoutProperties from "/vercel/path0/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/objectWithoutProperties.js";
var _excluded = ["status"],
    _excluded2 = ["dateLabel", "date", "cancelAt", "currentPeriodEnd", "onSlotCloseCallback", "showCrossIcon", "canceledAtPeriodEnd", "isExpirePeriodEnding"],
    _excluded3 = ["dateLabel", "date"];

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

import _styled from "styled-components";
import { XMarkIcon } from '@heroicons/react/24/outline';
import { useTranslation } from 'next-i18next';
import { fromUnixTime } from 'date-fns';
import { formatDateToDayMonthYear } from '@restworld/utils-common';
import { Badge } from '@restworld/ui-ds-base';
import Title from '../title';
import IconButton from '../icon-button';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
export var FlexibleSlotCard = function FlexibleSlotCard(_ref) {
  var status = _ref.status,
      rest = _objectWithoutProperties(_ref, _excluded);

  return status === 'active' ? /*#__PURE__*/_jsx(ActiveFlexibleSlotCard, _objectSpread({
    status: "active"
  }, rest)) : /*#__PURE__*/_jsx(IdleFlexibleSlotCard, _objectSpread({
    status: "idle"
  }, rest));
};

var SlotCardWrapper = function SlotCardWrapper(_ref2) {
  var children = _ref2.children,
      orderNumber = _ref2.orderNumber,
      title = _ref2.title,
      isActive = _ref2.isActive,
      status = _ref2.status,
      isTrial = _ref2.isTrial;
  return /*#__PURE__*/_jsxs(SlotWrapper, {
    status: status,
    children: [/*#__PURE__*/_jsxs(SlotInfo, {
      isHeader: true,
      children: [/*#__PURE__*/_jsx(SlotOrderNumber, {
        status: status,
        children: /*#__PURE__*/_jsx(Title, {
          textColor: isActive ? 'primary-700' : 'neutral-200',
          fontSize: "small",
          fontWeight: "medium",
          children: orderNumber
        })
      }), /*#__PURE__*/_jsx(Title, {
        textColor: isActive ? 'neutral-700' : 'neutral-200',
        fontSize: "base",
        fontWeight: "medium",
        children: title
      }), isTrial && /*#__PURE__*/_jsx(Badge, {
        variant: isActive ? 'tertiary' : 'info',
        children: "Prova 10 giorni"
      })]
    }), /*#__PURE__*/_jsx(SlotInfo, {
      children: children
    })]
  });
};

export var ActiveFlexibleSlotCard = function ActiveFlexibleSlotCard(_ref3) {
  var _fromUnixTime;

  var dateLabel = _ref3.dateLabel,
      date = _ref3.date,
      cancelAt = _ref3.cancelAt,
      currentPeriodEnd = _ref3.currentPeriodEnd,
      onSlotCloseCallback = _ref3.onSlotCloseCallback,
      _ref3$showCrossIcon = _ref3.showCrossIcon,
      showCrossIcon = _ref3$showCrossIcon === void 0 ? true : _ref3$showCrossIcon,
      canceledAtPeriodEnd = _ref3.canceledAtPeriodEnd,
      isExpirePeriodEnding = _ref3.isExpirePeriodEnding,
      rest = _objectWithoutProperties(_ref3, _excluded2);

  var _useTranslation = useTranslation('common'),
      t = _useTranslation.t;

  var showNextPaymentDate = !!cancelAt && !!currentPeriodEnd && cancelAt <= currentPeriodEnd ? false : true;
  return /*#__PURE__*/_jsxs(SlotCardWrapper, _objectSpread(_objectSpread({
    isActive: true
  }, rest), {}, {
    children: [/*#__PURE__*/_jsxs(_StyledDiv, {
      children: [/*#__PURE__*/_jsxs(_StyledDiv2, {
        children: [showNextPaymentDate && /*#__PURE__*/_jsxs(_StyledDiv3, {
          children: [/*#__PURE__*/_jsx(Title, {
            textColor: isExpirePeriodEnding ? 'orange-700' : 'primary-700',
            fontSize: "small",
            fontWeight: "medium",
            twStyle: {
              "fontSize": "0.875rem !important",
              "lineHeight": "1.25rem !important"
            },
            children: dateLabel
          }), /*#__PURE__*/_jsx(Title, {
            textColor: isExpirePeriodEnding ? 'orange-700' : 'primary-700',
            fontSize: "small",
            fontWeight: "bold",
            children: date
          })]
        }), showCrossIcon && /*#__PURE__*/_jsx(IconButton, {
          ariaLabel: "flexible-slot-cancel-icon",
          size: "sm",
          Icon: XMarkIcon,
          wrapperStyle: {
            "display": "block",
            "@media (min-width: 768px)": {
              "display": "none"
            }
          },
          onClick: onSlotCloseCallback,
          variant: "restworld"
        })]
      }), /*#__PURE__*/_jsx(SlotBadge, {
        variant: "tertiary",
        children: canceledAtPeriodEnd && cancelAt ? "".concat(t('canceled_at_period_end'), " ").concat(formatDateToDayMonthYear((_fromUnixTime = fromUnixTime(cancelAt)) === null || _fromUnixTime === void 0 ? void 0 : _fromUnixTime.toISOString())) : t('active')
      })]
    }), /*#__PURE__*/_jsx(IconButton, {
      ariaLabel: "flexible-slot-cancel-icon",
      size: "sm",
      Icon: XMarkIcon,
      wrapperStyle: showCrossIcon ? {
        "display": "none",
        "@media (min-width: 768px)": {
          "display": "grid"
        }
      } : {
        "display": "none",
        "@media (min-width: 768px)": {
          "display": "grid",
          "visibility": "hidden",
          "&.tooltip > .tooltip-arrow:before": {
            "visibility": "hidden"
          },
          "&[role=\"tooltip\"] > [data-popper-arrow]:before": {
            "visibility": "hidden"
          },
          "&[role=\"tooltip\"] > [data-popper-arrow]:after": {
            "visibility": "hidden"
          }
        }
      },
      onClick: onSlotCloseCallback,
      variant: "restworld"
    })]
  }));
};
export var IdleFlexibleSlotCard = function IdleFlexibleSlotCard(_ref4) {
  var dateLabel = _ref4.dateLabel,
      date = _ref4.date,
      rest = _objectWithoutProperties(_ref4, _excluded3);

  return /*#__PURE__*/_jsx(SlotCardWrapper, _objectSpread(_objectSpread({}, rest), {}, {
    children: /*#__PURE__*/_jsx(Badge, {
      variant: "neutral",
      children: /*#__PURE__*/_jsxs(_StyledDiv4, {
        children: [/*#__PURE__*/_jsx(Title, {
          textColor: "neutral-200",
          fontSize: "small",
          fontWeight: "medium",
          twStyle: {
            "fontSize": "0.875rem !important",
            "lineHeight": "1.25rem !important"
          },
          children: dateLabel
        }), /*#__PURE__*/_jsx(Title, {
          textColor: "neutral-200",
          fontSize: "small",
          fontWeight: "bold",
          children: date
        })]
      })
    })
  }));
};
export default FlexibleSlotCard;

var SlotWrapper = /*#__PURE__*/_styled.div.withConfig({
  displayName: "flexible-slot-card__SlotWrapper",
  componentId: "sc-1ts8x0u-0"
})(["", ";", ""], {
  "display": "inline-flex",
  "width": "100%",
  "flexDirection": "column",
  "gap": "0.625rem",
  "alignSelf": "stretch",
  "borderRadius": "0.5rem",
  "padding": "1rem",
  "@media (min-width: 768px)": {
    "flexDirection": "row",
    "alignItems": "center",
    "justifyContent": "space-between"
  },
  "@media (min-width: 1024px)": {
    "height": "56px"
  }
}, function (_ref5) {
  var status = _ref5.status;

  if (status === 'active') {
    return {
      "--tw-bg-opacity": "1",
      "backgroundColor": "rgb(240 235 248 / var(--tw-bg-opacity))"
    };
  }

  return {
    "borderWidth": "1px",
    "--tw-border-opacity": "1",
    "borderColor": "rgb(222 222 225 / var(--tw-border-opacity))"
  };
});

var SlotOrderNumber = /*#__PURE__*/_styled.div.withConfig({
  displayName: "flexible-slot-card__SlotOrderNumber",
  componentId: "sc-1ts8x0u-1"
})(function (_ref6) {
  var status = _ref6.status;
  return [{
    "display": "flex",
    "height": "1.5rem",
    "alignItems": "center",
    "justifyContent": "center",
    "borderRadius": "0.25rem",
    "borderWidth": "1px",
    "paddingLeft": "0.5rem",
    "paddingRight": "0.5rem",
    "paddingTop": "0.125rem",
    "paddingBottom": "0.125rem"
  }, status === 'active' ? {
    "--tw-border-opacity": "1",
    "borderColor": "rgb(72 36 133 / var(--tw-border-opacity))",
    "--tw-bg-opacity": "1",
    "backgroundColor": "rgb(240 235 248 / var(--tw-bg-opacity))"
  } : {
    "--tw-border-opacity": "1",
    "borderColor": "rgb(102 102 118 / var(--tw-border-opacity))",
    "--tw-bg-opacity": "1",
    "backgroundColor": "rgb(222 222 225 / var(--tw-bg-opacity))"
  }];
});

var SlotInfo = /*#__PURE__*/_styled.div.withConfig({
  displayName: "flexible-slot-card__SlotInfo",
  componentId: "sc-1ts8x0u-2"
})(["", ";", ""], {
  "display": "flex",
  "alignItems": "center",
  "gap": "0.5rem"
}, function (_ref7) {
  var isHeader = _ref7.isHeader;
  return isHeader ? {
    "justifyContent": "flex-start"
  } : {
    "justifyContent": "space-between"
  };
});

var SlotBadge = /*#__PURE__*/_styled(Badge).withConfig({
  displayName: "flexible-slot-card__SlotBadge",
  componentId: "sc-1ts8x0u-3"
})(["", ""], {
  "maxWidth": "fit-content",
  "borderRadius": "0.25rem",
  "textTransform": "lowercase"
});

var _StyledDiv = /*#__PURE__*/_styled("div").withConfig({
  displayName: "flexible-slot-card___StyledDiv",
  componentId: "sc-1ts8x0u-4"
})({
  "display": "flex",
  "width": "100%",
  "flexDirection": "column",
  "gap": "0.5rem",
  "@media (min-width: 768px)": {
    "width": "auto",
    "flexDirection": "row",
    "alignItems": "center",
    "justifyContent": "space-between"
  }
});

var _StyledDiv2 = /*#__PURE__*/_styled("div").withConfig({
  displayName: "flexible-slot-card___StyledDiv2",
  componentId: "sc-1ts8x0u-5"
})({
  "display": "flex",
  "width": "100%",
  "alignItems": "center",
  "justifyContent": "space-between",
  "@media (min-width: 768px)": {
    "width": "auto"
  }
});

var _StyledDiv3 = /*#__PURE__*/_styled("div").withConfig({
  displayName: "flexible-slot-card___StyledDiv3",
  componentId: "sc-1ts8x0u-6"
})({
  "display": "flex",
  "gap": "0.25rem"
});

var _StyledDiv4 = /*#__PURE__*/_styled("div").withConfig({
  displayName: "flexible-slot-card___StyledDiv4",
  componentId: "sc-1ts8x0u-7"
})({
  "display": "flex",
  "gap": "0.25rem"
});